<template>
  <div>
    <OfferedSoldWanted />
    <!-- <Tweets/> -->
  </div>
</template>

<script>
import OfferedSoldWanted from '@/views/search/OfferedSoldWanted'
// import Tweets from './Tweets'

export default {
  name: 'Home',
  components: {
    OfferedSoldWanted,
    //    Tweets
  },
}
</script>
